import { createDebugger } from '@iotize/common/debug';

const prefix = '@iotize/tap/protocol/common';

export const debug = createDebugger(prefix);
